const MediaDeviceKinds = {
	AUDIO_INPUT: 'audioinput',
	VIDEO_INPUT: 'videoinput',
	AUDIO_OUTPUT: 'audiooutput',
};

export default MediaDeviceKinds;
